<template>
  <custom-dialog
    :openDialog="isOpen"
    :widthDialog="'600px'"
    :classDialog="'create-dialog custome-dialog'"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('dialogClosed')"
  >
    <template #header>
      <div
        class="flex-row flex__center font-size__medium font-weight__bold margin-top-10"
      >TỪ CHỐI YÊU CẦU</div>
    </template>

    <template #body>
      <div class="form-info">
        <el-form ref="form" :model="form" :rules="rules" inline-message>
          <div class="group__info">
            <div class="content">
              <div class="form-input">
                <el-form-item class="custom-label__input width25" prop="note">
                  <span class="label-input field-needed">Nội dung phản hồi:</span>
                  <el-input
                    type="textarea"
                    :autosize="{ minRows: 2, maxRows: 5}"
                    class="input-border__bottom input-border__radius__0 input-font__bold"
                    v-model="form.note"
                    size="mini"
                  ></el-input>
                </el-form-item>
              </div>
            </div>
          </div>
        </el-form>
      </div>
    </template>

    <template #footer>
      <div class="flex-row flex__right form-button__action">
        <el-button size="mini" class="addDocs color__red btn-none__border" @click="cancel()">
          <i class="fas fa-times-circle font-size__small"></i>
          &nbsp;Hủy yêu cầu
        </el-button>
        <el-button class="btn__cancel btn-none__border" @click="$emit('closeDialog')">Đóng</el-button>
      </div>
    </template>
  </custom-dialog>
</template>

<script>
import hanhchinhService from "../../../services/hanhchinhService";
import handleRequestErrorMixin from "../../handleRequestErrorMixin";
export default {
  props: ["isOpen", "data"],
  mixins: [handleRequestErrorMixin],
  components: {
    customDialog: () => import("../../common/custom-dialog.vue")
  },
  created() {
    this.getAction();
  },
  computed: {
    caseMasterId() {
      return this.data.caseMasterId;
    }
  },
  data() {
    return {
      listAction: [],
      form: {
        note: null
      },
      rules: {
        note: [
          {
            required: true,
            message: "Vui lòng nhập nội dung phản hồi",
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    getAction() {
      hanhchinhService.getAction(this.caseMasterId).then(respone => {
        this.listAction = [];
        respone.data.actions.forEach(action => {
          this.listAction.push(action.actionCode);
        });
      });
    },

    cancel() {
      this.listAction.forEach(action => {
        if (action === "huyyeucau1" || action === "huyyeucau2") {
          this.$refs.form.validate(valid => {
            if (valid) {
              let submitForm = {
                caseMasterId: this.caseMasterId,
                action,
                note: this.form.note
              };
              try {
                this.$confirm("Bạn có muốn hủy yêu cầu này?", {
                  confirmButtonText: "Xác nhận",
                  cancelButtonText: "Hủy bỏ",
                  type: "warning"
                }).then(() => {
                  hanhchinhService
                    .cancelCommand(submitForm)
                    .then(() => {
                      this.notify(
                        "Thông báo",
                        "Hủy yêu cầu thành công",
                        "success",
                        2000
                      );
                    })
                    .catch(error => this.commonHandleRequestError(error));
                    this.$emit('closeDialog', {
                      respone: true
                    })
                });
              } catch (error) {
                this.notify("Lỗi", "Lỗi không xác định  !", "error", 2000);
              }
            } else {
              this.notify("Lỗi", "Chưa nhập nội dung phản hồi!", "error", 2000);
            }
          });
        }
      });
    }
  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/adminstration/ketluan/ketLuanChiDao_TuChoiDialog.vue